import React, { useState } from "react";
import { View, StyleSheet, Image } from "react-native";
import NtSectionInputField from "../general/NtSectionInputField";
import NtText from "../../../components/NtText";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionButton from "../general/NtSectionButton";
import NtTextInput from "../../../components/NtTextInput";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtImageBackground from "../general/NtImageBackground";
import { validateEmail } from "../../../common/utils/ControllerUtils";
import { sendEmail, sendNotificationEmail } from "../../../api/notification";
import Logger from "../../../common/utils/Logger";
import { useMobile } from "../../../hooks/useMobile";

function NtInquirySection({ title, subject }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const isMobile = useMobile();

  const isRequired = () => {
    return name && email && phone && company && message;
  };

  const handleSend = async () => {
    if (!isRequired()) {
      setError("All Fields are required.");
      return;
    } else if (!validateEmail(email)) {
      setError("Please enter e valid email address");
      return;
    }

    setLoading(true);

    const params = {
      subject: subject,
      message: `Contact information<br><br>Name: ${name}<br>Email: ${email}<br>Phone: ${phone}<br>Company: ${company}<br><br>Brief message:<br>${message}`,
    };

    setError("");
    const response = await sendNotificationEmail("nick@ntconnect.com", params);

    if (response.ok) {
      Logger("Successfully sent email");
      setName("");
      setEmail("");
      setPhone("");
      setCompany("");
      setMessage("");
    }

    setLoading(false);
  };

  return (
    <NtMarketingSectionContainer style={styles.container}>
      <NtSectionTitle style={{}}>INQUIRY</NtSectionTitle>
      <View
        style={{
          alignItems: "center",
          marginTop: 40,
        }}
      >
        <NtImageBackground
          containerStyle={{ height: "100%" }}
          opaqueStyle={{ borderRadius: 30 }}
          imageStyle={{ borderRadius: 30 }}
          image={require("../../../assets/images/marketing/d57b984d313cf86ca92f895da1bc541f149e7f7e.jpg")}
        />

        {/* form..... */}
        <View
          style={{
            width: "100%",
            maxWidth: "80%",
            paddingTop: 60,
            paddingBottom: 60,
          }}
        >
          <View
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(10px)",
              borderRadius: 6,
              borderWidth: 1,
              borderColor: "white",
              padding: 15,
            }}
          >
            <NtText style={{ color: "white", fontSize: 12, fontWeight: "500" }}>
              {title}
            </NtText>
          </View>

          <View
            style={{
              flexDirection: isMobile ? "column" : "row",
              marginTop: 20,
            }}
          >
            <NtSectionInputField
              containerStyle={{
                flex: 1,
                marginRight: isMobile ? 0 : 10,
              }}
              title={"Name"}
              placeholder={"Enter your name"}
              value={name}
              setValue={(text) => setName(text)}
            />
            <NtSectionInputField
              containerStyle={{ flex: 1, marginTop: isMobile ? 10 : 0 }}
              title={"Email"}
              placeholder={"Enter your email"}
              value={email}
              setValue={(text) => setEmail(text)}
            />
          </View>

          <View
            style={{
              flexDirection: isMobile ? "column" : "row",
              marginTop: 15,
            }}
          >
            <NtSectionInputField
              containerStyle={{ flex: 1, marginRight: isMobile ? 0 : 10 }}
              title={"Phone Number"}
              placeholder={"Enter Phone Number"}
              value={phone}
              setValue={(text) => setPhone(text)}
            />
            <NtSectionInputField
              containerStyle={{ flex: 1, marginTop: isMobile ? 10 : 0 }}
              title={"Company"}
              placeholder={"Enter your Company Info"}
              value={company}
              setValue={(text) => setCompany(text)}
            />
          </View>

          <NtText
            style={{
              fontSize: 14,
              fontWeight: "700",
              color: "white",
              marginTop: 15,
              marginBottom: 4,
              marginLeft: 4,
            }}
          >
            Message
          </NtText>

          <NtTextInput
            containerStyle={{
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(10px)",
              borderRadius: 6,
            }}
            textColor="white"
            placeholder={"Write a message"}
            placeholderTextColor={"#e8e8e8"}
            numberOfLines={4}
            multiline={true}
            value={message}
            onChangeText={(text) => setMessage(text)}
          />

          <NtSectionButton
            title="Send"
            containerStyle={{ marginTop: 15, paddingTop: 8, paddingBottom: 8 }}
            color="white"
            loading={loading}
            onPress={() => {
              handleSend();
            }}
          />
          <NtText
            style={{
              marginTop: 6,
              color: "red",
              fontWeight: "600",
              fontSize: 13,
            }}
          >
            {error}
          </NtText>
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 20,
    paddingBottom: 60,
    alignItems: "center",
  },
});

export default NtInquirySection;
